/**
 * The enum used for increase or decrease indentation of a block
 * Used by setIndentation API
 */
export enum CompatibleIndentation {

    /**
     * Increase indentation
     */
    Increase,

    /**
     * Decrease indentation
     */
    Decrease,
}
